import Joi from 'joi';

/**
 * Schema for existing outbox record validation.
 */
export const updateOutboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
